// Editable business configuration for PepsWorld UK.
export const BRAND = {
  name: "PepsWorld UK",
  slogan: "Your. Final. Form.",
  tagline: "Premium research resources. Built for precision.",
};

// Telegram contact. Username (without @) and click-to-chat link.
export const TELEGRAM_USERNAME = "pepsworlduk";
export const CONTACT_EMAIL = "pepsworlduk@gmail.com";
export const CONTACT_HOURS = "Mon–Fri, 9:00–17:00 GMT";

export const TELEGRAM_URL = `https://t.me/${TELEGRAM_USERNAME}`;
// Telegram group/community invite link (join the community).
export const TELEGRAM_COMMUNITY_URL = "https://t.me/+sMLkqRkmuVY3MDFk";
// Telegram profile/chat link (t.me does not support pre-filled text).
export const buildTelegramLink = (_text) => TELEGRAM_URL;

export const LEGAL_NOTICE =
  "All products supplied by PepsWorld UK are intended strictly for lawful laboratory, analytical, educational and research purposes only. They are not intended to diagnose, treat, cure or prevent any disease, and are not for human or veterinary consumption.";
